module.exports = __webpack_public_path__ + "img/54_42.707ef40c.png";